import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import {
  getData,
  getDataWithDotNet,
} from "../../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../../interfaces/response";

export interface IPendingAdminUnlockUser {
  transactionReferenceNumber: string;
  sssoUserId: string;
  lockReasonId: number;
  lockReason: string;
  additionalLockDescription: string | null;
  unlockReasonId: number;
  additionalUnlockDescription: string;
  unlockReason: string;
  workflowCode: string;
  lockedUserMail: string;
  lockedUserName: string;
  dateInitiated: string;
}

const getPendingAdminUnlockUsers = async (): Promise<
  IResponse<IPendingAdminUnlockUser[]>
> => {
  const { data } = await getData(`${ajaxEndpoints.PENDING_ADMIN_UNLOCK_USERS}`);
  return data;
};

export default function useGetPendingAdminUnlockUsers() {
  return useQuery<IResponse<IPendingAdminUnlockUser[]>, Error>(
    ["getPendingAdminUnlockUsers"],
    () => getPendingAdminUnlockUsers(),
    {
      refetchOnWindowFocus: false,
    },
  );
}
